import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';

// Import des services
import { SecurityService } from '../services/security.service';
import { ErrorService } from '../services/error.service';
import { UserService } from '../services/user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

    constructor(public route: Router, public userService: UserService, public errorService: ErrorService) {}

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree 
    {

        if (!this.userService.isFullyAuthenticated()) {
            this.userService.logout();
            return false;
        }

        let userRoles: Array<string> = [];
        let userGroups: Array<string> = [];
        let userAttributes: Array<string> = [];
        let otp : boolean = false;
        let cgu: boolean = false;

        const accessInformations = next.data;

        if (accessInformations.hasOwnProperty('roles')) {
            userRoles = accessInformations.roles;
        }

        if (accessInformations.hasOwnProperty('groups')) {
            userGroups = accessInformations.groups;
        }

        if (accessInformations.hasOwnProperty('attributes')) {
            userAttributes = accessInformations.attributes;
        }

        if (accessInformations.hasOwnProperty('otp')) {
            otp = accessInformations.otp;
        }

        if (accessInformations.hasOwnProperty('cgu')) {
            cgu = accessInformations.cgu;
        }

        // Préparation des données
        let authorizationAccess = false;

        // Parcours des Rôles donnés sur la route
        for (const currentRole of userRoles) {
            // Test du rôle vis à vis de l'identité de l'utilisateur
            if (this.userService.hasRealmRole(currentRole) || this.userService.hasResourceRole(currentRole)) {
                authorizationAccess = true;
            }
        }

        // Parcours des attributs donnés sur la route
        for (const currentGroup of userGroups) {
            // Test de l'existance de l'attribut pour l'utilisateur
            if (this.userService.hasGroup(currentGroup)) {
                authorizationAccess = true;
            }
        }

        // Parcours des attributs donnés sur la route
        for (const currentAttrubute of userAttributes) {
            // Test de l'existance de l'attribut pour l'utilisateur
            if (this.userService.hasAttribute(currentAttrubute)) {
                authorizationAccess = true;
            }
        }

        if (
            this.userService.currentUser.symfonyUser.clients.length == 0
            || typeof this.userService.currentUser.symfonyUser.defaultFolder === 'undefined'
        ) {
            authorizationAccess = false;
        }

        if (cgu == true && this.userService.currentUser.cgu == true) {
            authorizationAccess = false;
        }

        // Interpretation du status d'autorisation
        if (authorizationAccess === true) {       // SI le status est positif...
            return true;                            // On autorise l'accès
        } else {     
            this.userService.logout();
            return false;                           // On renvoie le status négatif
        }
    }
}
